/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// actions
import { surveyActions } from '../../../application/actions/survey';
// configs
import routes from '../../../application/config/routes';
// components
import UsabilityAndSatisfaction from '../../components/organisms/surveys/UsabilityAndSatisfaction';
import BecauseMember from '../../components/organisms/surveys/BecauseMember';
import Needs from '../../components/organisms/surveys/Needs';
import Abandonment from '../../components/organisms/surveys/Abandonment';
import AlreadyMember from '../../components/organisms/surveys/AlreadyMember';
import sendAnalitycs from '../../../domain/utils/utilitarios-frontend-coopeuch/Analytics';
import dataLayerObject from '../../../domain/utils/dataLayerObject';
// data
import usabilityAndSatisfactionData from './dumb/usabilityAndSatisfaction.json';
import becauseMemberData from './dumb/becauseMember.json';
import abandonmentData from './dumb/abandonment.json';
import needsData from './dumb/needs.json';
import alreadyMemberData from './dumb/alreadyMember.json';
import edgeCases from '../../localData/edgeCases';
// const
const urlsToRedirect = {
  13: 'https://webprivado.coopeuch.cl/#/',
  14: 'https://webprivado.coopeuch.cl/#/',
  15: 'https://puntoscoopeuch.cl/?active=pro#section-promos',
  16: 'https://www.coopeuch.cl/personas/credito-consumo.html',
  17: 'https://www.coopeuch.cl/personas/',
  18: 'https://www.coopeuch.cl/personas/centro-de-ayuda',
};

const Survey = (props) => {
  const {
    type,
    disabled,
    changeForeignState,
    foreignState,
    validationRequireFields,
    onReceiveSurveyData,
    onCloseModal,
  } = props;
  const [surveyData, setSurveyData] = useState({ questions: [] });
  const [state, setState] = useState('');
  const [responses, setResponses] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [optionsSelected, setOptionsSelected] = useState([]);
  const [canContinue, setCanContinue] = useState(false);
  const [currentEdgeCase, setCurrentEdgeCase] = useState({
    title: '',
  });

  const appRoutes = routes();
  const dispatch = useDispatch();
  const registerResponses = useSelector((store) => store.entities.survey.registerResponses);
  const isLoadingRegisterSurvey = useSelector((store) => store.ui.loaders.isLoadingRegisterSurvey);

  useEffect(() => {
    setState('initial');
    switch (type) {
      case 'becauseMember':
        setSurveyData(becauseMemberData);
        break;
      case 'needs':
        setSurveyData(needsData);
        break;
      case 'usabilityAndSatisfaction':
        setSurveyData(usabilityAndSatisfactionData);
        break;
      case 'abandonment':
        setSurveyData(abandonmentData);
        break;
      case 'alreadyMember':
        setSurveyData(alreadyMemberData);
        break;
      default:
        break;
    }
  }, []);

  useEffect(() => {
    if (currentQuestion === surveyData.questions.length && responses.length > 0) {
      if (registerResponses.success) {
        setCurrentEdgeCase(edgeCases.successful);
        
        setState(`sent${type === 'becauseMember' ? '-becauseMember' : ''}`);
        if (type === 'alreadyMember') {
          window.location = urlsToRedirect[responses[0].idOption];
        }
      } else if (registerResponses.error) {
        setCurrentEdgeCase(edgeCases.errorSurveyAbandonment);
        setState(`error${type === 'becauseMember' ? '-becauseMember' : ''}`);
      }
      if (type === 'becauseMember' && (registerResponses.success || registerResponses.error))
        changeForeignState(
          `${registerResponses.success ? 'sent-becauseMember' : 'error-becauseMember'}`
        );
      setCurrentQuestion(1);
    }
  }, [registerResponses]);

  useEffect(() => {
    if (optionsSelected.length) {
      let isValid = true;
      optionsSelected.forEach((element) => {
        const totalOptionSelected = surveyData.questions[currentQuestion - 1].alternatives.filter(
          (el) => el.idOption === element.idOption
        )[0];
        if (totalOptionSelected.comment)
          if (totalOptionSelected.comment.required)
            if (element.comment.length < 2) {
              isValid = false;
              // eslint-disable-next-line no-useless-return
              return;
            }
      });
      setCanContinue(isValid);
    }
    if (onReceiveSurveyData)
      onReceiveSurveyData({ idSurvey: surveyData.idSurvey, responses: optionsSelected });
  }, [optionsSelected]);

  useEffect(() => {
    if (responses.length > 0) {
      // COMMENT: obtenemos la descripcion o valor de la opcion elegida para el caso donde no es multiple
      let descriptionOptionSelected = '';
      let comment = '';
      if (surveyData.questions[currentQuestion - 1].optionsMultiple === false) {
        descriptionOptionSelected = surveyData.questions[currentQuestion - 1].alternatives.filter(
          (el) => el.idOption === optionsSelected[0].idOption
        )[0].description;
        comment = optionsSelected[0].comment;
      }
      if (currentQuestion === surveyData.questions.length) {
        // COMMENT: Si estamos en la ulitma pregunta, enviamos las respuestas al servicio
        const payloadRegisterResponses = {
          idSurvey: surveyData.idSurvey,
          responses,
        };
        dispatch(surveyActions.registerResponses(payloadRegisterResponses));
        if (type === 'becauseMember') {
          const idOptionsSelected = optionsSelected.map((el) => el.idOption);
          const reasons = surveyData.questions[currentQuestion - 1].alternatives
            .filter((el) => idOptionsSelected.includes(el.idOption))
            .map((el) => el.description);
          sendAnalitycs(dataLayerObject.SURVEY_BECAUSE_MEMBER_SENDING, [
            {
              key: 'eve-lab',
              param: 'motivo',
              value: reasons.toString(),
            },
          ]);
          // COMMENT: guardamos en el storage, los nombres de los productos seleccionados
          sessionStorage.setItem('products', reasons.join('%'));
        } else if (type === 'usabilityAndSatisfaction') {
          sendAnalitycs(dataLayerObject.SURVEY_USABILITY_SATISFACTION_2, [
            {
              key: 'eve-lab',
              param: 'puntuacion-comentario',
              value: `${descriptionOptionSelected} - ${comment}`,
            },
          ]);
        } else if (type === 'abandonment') {
          sendAnalitycs(dataLayerObject.SURVEY_ABANDONMENT_SENDING, [
            {
              key: 'eve-cat',
              param: 'ubicacion',
              value: window.location.pathname,
            },
            {
              key: 'eve-acc',
              param: 'paso',
              value: window.location.pathname,
            },
            {
              key: 'eve-lab',
              param: 'opcion-comentario',
              value: `${descriptionOptionSelected} - ${comment}`,
            },
          ]);
        }
        // TODO: esto es temporal, sacar cuando el servicio survey sea llamado
        handleTemporalSendingResponses('type');
      } else if (type === 'alreadyMember') {
        // sendAnalitycs(dataLayerObject.SURVEY_);
      } else {
        if (type === 'usabilityAndSatisfaction') {
          sendAnalitycs(dataLayerObject.SURVEY_USABILITY_SATISFACTION_1, [
            {
              key: 'eve-lab',
              param: 'puntuacion-comentario',
              value: `${descriptionOptionSelected} - ${comment}`,
            },
          ]);
        }
        setCurrentQuestion((prev) => prev + 1);
      }
      setOptionsSelected([]);
    }
  }, [responses]);

  const handleTemporalSendingResponses = (surveyName) => {
    setCurrentEdgeCase(edgeCases.successful);
    setState(`sent${surveyName === 'becauseMember' ? '-becauseMember' : ''}`);
    setCurrentQuestion(1);
  }

  const handleSelectOptions = ({ idOption, selected }) => {
    let optionsSelectedTemp = [];
    if (surveyData.questions[currentQuestion - 1].optionsMultiple) {
      optionsSelectedTemp =
        selected === true
          ? [...optionsSelected, { idOption, comment: '' }]
          : optionsSelected.filter((el) => el.idOption !== idOption);
    } else optionsSelectedTemp = [{ idOption, comment: '' }];

    setOptionsSelected(optionsSelectedTemp);
  };

  const handleChangeComment = ({ idOption, comment }) => {
    const optionsSelectedTemp = optionsSelected.map((el) => {
      if (el.idOption === idOption) {
        return {
          ...el,
          comment,
        };
      }
      return el;
    });
    setOptionsSelected(optionsSelectedTemp);
  };

  const handleClickContinue = () => {
    setResponses([...responses, ...optionsSelected]);
    // COMMENT: despues de hacer click para ir a la pregunta 2, llamammos el load de la siguiente
    setCanContinue(false);
  };

  const handleClickOptionMember = ({ idOption /* , description */ }) => {
    const clicketText = alreadyMemberData.questions[0].alternatives.filter((el) => el.idOption === idOption)[0].description || '';
    sendAnalitycs(dataLayerObject.BORDE_ALREADY_MEMBER_ELECTION, [
      {
        key: 'eve-lab',
        param: 'eleccion',
        value: clicketText,
      },
    ]);
    
    setOptionsSelected([{ idOption, /* description, */ comment: '' }]);
    setResponses([{ idOption, comment: '' }]);
    
  };

  const handleRetrySendResponses = () => {
    setState('initial');
    if (type === 'becauseMemeber') changeForeignState('initial');
  };

  const handleExitFlow = (surveyType) => {
    if (surveyType === 'usabilityAndSatisfaction') {
      sendAnalitycs(dataLayerObject.SURVEY_USABILITY_SATISFACTION_EXIT);
    } else if (surveyType === 'abandonment') {
        sendAnalitycs(dataLayerObject.SURVEY_ABANDONMENT_EXIT, [
          {
            key: 'page',
            param: 'paso',
            value: window.location.pathname,
          },
        ]);
    }
    window.location = appRoutes.landing.path;
  };

  const handleResumeContratation = () => {
    onCloseModal();
    sendAnalitycs(dataLayerObject.SURVEY_ABANDONMENT_RETURN, [
      {
        key: 'eve-acc',
        param: 'paso',
        value: window.location.pathname,
      },
    ]);
  };

  return (
    surveyData.questions.length && (
      <>
        {type === 'usabilityAndSatisfaction' && (
          <UsabilityAndSatisfaction
            state={state}
            currentEdgeCase={currentEdgeCase}
            optionSelected={optionsSelected[0] || {}}
            currentQuestion={currentQuestion}
            questions={surveyData.questions}
            canContinue={canContinue}
            onClickContinue={handleClickContinue}
            onSelectOption={handleSelectOptions}
            onChangeComment={handleChangeComment}
            onExitFlow={handleExitFlow}
            onRetrySendResponses={handleRetrySendResponses}
          />
        )}
        {type === 'abandonment' && (
          <Abandonment
            state={state}
            currentEdgeCase={currentEdgeCase}
            optionSelected={optionsSelected[0] || {}}
            question={surveyData.questions[0]}
            canContinue={canContinue}
            onSendResponses={handleClickContinue}
            onSelectOption={handleSelectOptions}
            onChangeComment={handleChangeComment}
            onResumeContratation={handleResumeContratation}
            onExitFlow={handleExitFlow}
            onRetrySendResponses={handleRetrySendResponses}
          />
        )}
        {type === 'becauseMember' && (
          <BecauseMember
            state={foreignState}
            optionsSelected={optionsSelected}
            question={surveyData.questions[0]}
            disabled={disabled}
            onSelectOption={handleSelectOptions}
            onChangeComment={handleChangeComment}
            onSendResponses={handleClickContinue}
            onRetrySendResponses={handleRetrySendResponses}
          />
        )}
        {type === 'alreadyMember' && (
          <AlreadyMember
            isLoadingRegisterSurvey={isLoadingRegisterSurvey}
            question={surveyData.questions[0]}
            onSelectOption={handleClickOptionMember}
          />
        )}
        {type === 'needs' && (
          <Needs
            validationRequireFields={validationRequireFields}
            // state={foreignState}
            optionsSelected={optionsSelected}
            question={surveyData.questions[0]}
            // disabled={disabled}
            onSelectOption={handleSelectOptions}
          />
        )}
      </>
    )
  );
};

export default Survey;
